"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link NamedTopicViewSpecification}
 */
var NamedTopicViewSpecificationSerialiserClass = /** @class */ (function (_super) {
    __extends(NamedTopicViewSpecificationSerialiserClass, _super);
    function NamedTopicViewSpecificationSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link NamedTopicViewSpecification} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link NamedTopicViewSpecification} to be written
     */
    NamedTopicViewSpecificationSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.name);
        Codec.writeString(bos, value.specification);
    };
    return NamedTopicViewSpecificationSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.NamedTopicViewSpecificationSerialiserClass = NamedTopicViewSpecificationSerialiserClass;
/**
 * The {@link NamedTopicViewSpecificationSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.NamedTopicViewSpecificationSerialiser = new NamedTopicViewSpecificationSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-views/named-topic-view-specification-serialiser.js
// module id = 2077
// module chunks = 1